export enum FontFamily {
  Manrope = 'Manrope',
  Lora = 'Lora',
}
